/**
 * Guided Technical Sheet Module Manifest
 *
 * Facilitated technical-sheet editor (spec 0048 §7–§8 / request 0278).
 * Key `guidedtechnicalsheet` matches Module.actionProperties.redirectTo.
 *
 * Skeleton params (`processes` / `components`) were removed: inclusion copies a
 * model sheet (`defaultSheetId`); process order comes from `route.order`.
 */
export const guidedTechnicalSheetManifest = {
    key: 'guidedtechnicalsheet',
    version: 2,
    name: 'Ficha técnica têxtil',
    parameters: [
        {
            key: 'guidedKind',
            label: 'Tipo de ficha guiada',
            type: 'enum',
            scope: 'module',
            options: [{ value: 'dyeing', label: 'Tingimento textil' }],
            default: 'dyeing',
        },
        {
            key: 'defaultSheetId',
            label: 'Ficha modelo',
            type: 'entity',
            scope: 'module+org',
            entity: 'TechnicalSheet',
            multiple: false,
            default: '',
        },
        {
            key: 'variationOptionIds',
            label: 'Opcoes de variacao',
            type: 'entity',
            scope: 'module+org',
            entity: 'VariationOption',
            multiple: true,
            default: [],
        },
    ],
};
//# sourceMappingURL=guidedTechnicalSheet.manifest.js.map